import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export const myProfileInitialstate: any = {
  myProfileData: {},
  isFetched: false,
};
const MyProfileModuleSlice = createSlice({
  name: "myProfile",
  initialState: myProfileInitialstate,
  reducers: {
    setProfileData: (state: any, action: PayloadAction<any>) => {
      state.myProfileData = action.payload;
      state.isFetched = true;
    },
    setProfileFetched: (state: any, action: PayloadAction<boolean>) => {
      state.isFetched = action.payload;
    },
  },
});

export const { setProfileData, setProfileFetched } =
  MyProfileModuleSlice.actions;
export default MyProfileModuleSlice.reducer;
